/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1PaymentsStatus = {
    Accepted: 'accepted',
    Pending: 'pending',
    Success: 'success',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const
export type V1PaymentsStatus =
    (typeof V1PaymentsStatus)[keyof typeof V1PaymentsStatus]

export function instanceOfV1PaymentsStatus(value: any): boolean {
    for (const key in V1PaymentsStatus) {
        if (Object.prototype.hasOwnProperty.call(V1PaymentsStatus, key)) {
            if (
                V1PaymentsStatus[key as keyof typeof V1PaymentsStatus] === value
            ) {
                return true
            }
        }
    }
    return false
}

export function V1PaymentsStatusFromJSON(json: any): V1PaymentsStatus {
    return V1PaymentsStatusFromJSONTyped(json, false)
}

export function V1PaymentsStatusFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PaymentsStatus {
    return json as V1PaymentsStatus
}

export function V1PaymentsStatusToJSON(value?: V1PaymentsStatus | null): any {
    return value as any
}

export function V1PaymentsStatusToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1PaymentsStatus {
    return value as V1PaymentsStatus
}
